import type { LeadRoutingConfig } from '@app/types/lead-routing';

export function resolveLeadRoutingPhone(
  config: LeadRoutingConfig | undefined,
  regionId: number | undefined | null,
  fallbackPhone: string,
): string {
  if (!config?.enabled || regionId == null) {
    return fallbackPhone;
  }

  const regionPhone = config.region_routing?.[`R${regionId}`]?.region_phone;
  return regionPhone ?? fallbackPhone;
}
